/**
 * Header Block for the Editor.js.
 *
 * @author Whizzy Corporation
 * @license The MIT License (MIT)
 * @version 1.0.0
 */

/**
 * @typedef {Object} HeaderData
 */
export default class Header {

	constructor({data, config, api}){
		this.api = api;
		this.config = config || {};

		this.data = {
			text: data.text || '',
			alignment: data.alignment !== undefined ? data.alignment : 'left',
			level: data.level !== undefined ? data.level : '2',
			type: data.lineType !== undefined ? data.lineType : 'normal',
			textColor: data.textColor !== undefined ? data.textColor : '#333333',
			backgroundColor: data.backgroundColor !== undefined ? data.backgroundColor : '#ffffff',
			borderColor: data.borderColor !== undefined ? data.borderColor : '#64b5ae'
		};

		this._setform = false;

		this._element = this.drawView();
		this._fontSizeArray = ['','','1.75rem', '1.53125rem', '1.3125rem'];

		// text復帰
		this._element.querySelector('div').innerHTML = this.data.text;
		// font-size復帰
		this._element.style.fontSize = this._fontSizeArray[this.data.level];
		// 線種変更
		this._changeType(this.data.type);
		// alignment変更
		this._changeAlignment(this.data.alignment);
		// 線色変更
		this._setColor();

		this.settings = [
			{
				name:'2',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="20" viewBox="0 0 40 40"><path d="M36.48,31.9,33,36.54a26.47,26.47,0,0,1-8-5.91A30.5,30.5,0,0,1,20,23a23.72,23.72,0,0,1-4.64,7.59,27.15,27.15,0,0,1-8,6.19L3.72,32.18a22.53,22.53,0,0,0,8.58-6.33,20.46,20.46,0,0,0,4.5-9.14H3.86V12.35H17.5V3.78h5.06v8.57H36.2v4.36H23.12a19.11,19.11,0,0,0,3.66,7.74,30.63,30.63,0,0,0,3.8,3.93A22.73,22.73,0,0,0,36.48,31.9Z" /></svg>',
				title: '大'
			},
			{
				name:'3',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="20" viewBox="0 0 40 40"><path d="M5.1,27.29V10H17.19V4.09h5.06V10H34.49V27.29H29.56V25.75H22.25V36.86H17.19V25.75H9.88v1.54Zm4.78-6h7.31V14.36H9.88Zm12.37,0h7.31V14.36H22.25Z" /></svg>',
				title: '中'
			},
			{
				name:'4',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 40 40" height="20" viewBox="0 0 40 40"><path d="M7.41,18.86a39,39,0,0,0,1.83-8l5.2,1.55a50.07,50.07,0,0,1-2,8.58,27.19,27.19,0,0,1-5.06,9.28l-4.36-3.8A22,22,0,0,0,7.41,18.86Zm10,11.25v-26h5.07v29c0,2.34-1.18,3.52-3.52,3.52H14.3l-1.69-4.93H16C16.92,31.75,17.39,31.23,17.39,30.11Zm19-3.8L31.88,30a29.08,29.08,0,0,1-4.5-8.16A44.72,44.72,0,0,1,25,12.53l4.92-1.69A44.33,44.33,0,0,0,32.16,19,29,29,0,0,0,36.38,26.31Z" /></svg>',
				title: '小',
			},
			{
				name:'left',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m10 23h28c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m10 45h28c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/></svg>',
				title: '左寄せ'
			},
			{
				name:'center',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m46 23c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m46 45c1.104 0 2-.896 2-2s-.896-2-2-2h-28c-1.104 0-2 .896-2 2s.896 2 2 2z"/></svg>',
				title: '中央寄せ'
			},
			{
				name:'right',
				icon:'<svg xmlns="http://www.w3.org/2000/svg" id="Layer" enable-background="new 0 0 64 64" height="20" viewBox="0 0 64 64" width="20"><path d="m54 8h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 52h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 19h-28c-1.104 0-2 .896-2 2s.896 2 2 2h28c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 30h-44c-1.104 0-2 .896-2 2s.896 2 2 2h44c1.104 0 2-.896 2-2s-.896-2-2-2z"/><path d="m54 41h-28c-1.104 0-2 .896-2 2s.896 2 2 2h28c1.104 0 2-.896 2-2s-.896-2-2-2z"/></svg>',
				title: '右寄せ'
			},
			{
				name:'normal',
				icon:'通常',
				title: '枠も線もない見出し'
			},
			{
				name:'left-line',
				icon:'左線',
				title: '左に線が引かれている見出し'
			},
			{
				name:'under-line',
				icon:'下線',
				title: '下に線が引かれている見出し',
			},
			{
				name:'updown-line',
				icon:'上下',
				title: '上下に線が引かれている見出し'
			},
			{
				name: 'border',
				icon:'枠線',
				title: '枠がある見出し'
			},
			{
				name: 'color',
				icon:'彩色',
				title: '色の設定'
			}
		]
	}

	drawView() {
		//console.log('Header.drawView');
		const containr = document.createElement('div');
		const textblock = document.createElement('div');
		const setblock = document.createElement('form');

		containr.classList.add('board-header');

		textblock.contentEditable = true;

		containr.appendChild(textblock);
		containr.appendChild(setblock);

		return containr;
	}

	render(){
		//console.log('Header.render');
		return this._element;
	}

	renderSettings(){
		const wrapper = document.createElement('div');
		this.settings.forEach(tune =>{
			let button = document.createElement('div');

			button.classList.add(this.api.styles.settingsButton);
			button.setAttribute('title', tune.title);
			button.innerHTML = tune.icon;
			wrapper.appendChild(button);

			this.api.tooltip.onHover(button, tune.title, {
				placement: 'top',
			});

			if(tune.name === 'normal' || tune.name === 'left-line' || tune.name === 'under-line' || tune.name === 'updown-line' || tune.name === 'border'){
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.type);
			}else if(tune.name === '2' || tune.name === '3' || tune.name === '4'){
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.level);
			}else if(tune.name === 'left' || tune.name === 'center' || tune.name === 'right'){
				button.classList.toggle(this.api.styles.settingsButtonActive, tune.name === this.data.position);
			}else{
				if(this._setform){
					button.classList.toggle(this.api.styles.settingsButtonActive);
				}
			}

			button.addEventListener('click', () => {
				if(tune.name === 'normal' || tune.name === 'left-line' || tune.name === 'under-line' || tune.name === 'updown-line' || tune.name === 'border'){

					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach(el => {
						if((el.innerHTML === '通常' || el.innerHTML === '左線' || el.innerHTML === '下線' || el.innerHTML === '上下' || el.innerHTML === '枠線')){
							el.classList.remove(this.api.styles.settingsButtonActive);
						}
					});

					button.classList.add(this.api.styles.settingsButtonActive);

					this._changeType(tune.name);

				}else if(tune.name === '2' || tune.name === '3' || tune.name === '4'){

					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach(el => {
						if((el.getAttribute('title') === '大' || el.getAttribute('title') === '中' || el.getAttribute('title') === '小') ){
							el.classList.remove(this.api.styles.settingsButtonActive);
						}
					});

					button.classList.add(this.api.styles.settingsButtonActive);

					this._changeSize(tune.name);

				}else if(tune.name === 'left' || tune.name === 'center' || tune.name === 'right'){

					wrapper.querySelectorAll(`.${this.api.styles.settingsButton}`).forEach(el => {
						if((el.getAttribute('title') === '左寄せ' || el.getAttribute('title') === '中央寄せ' || el.getAttribute('title') === '右寄せ') ){
							el.classList.remove(this.api.styles.settingsButtonActive);
						}
					});

					button.classList.add(this.api.styles.settingsButtonActive);

					this._changeAlignment(tune.name);

				}else if(tune.name === 'color'){

					button.classList.toggle(this.api.styles.settingsButtonActive);
					if(button.classList.contains(this.api.styles.settingsButtonActive)){
						this._showColorPicker(button);
						this._setform = true;
					}else{
						this._hideColorPicker();
						this._setform = false;
					}
				}
			});

		});

		return wrapper;
	}


	_changeType(tune){
		//console.log(`Header._changeType`);

		this._element.classList.remove(
			'board-header--normal',
			'board-header--left-line',
			'board-header--under-line',
			'board-header--updown-line',
			'board-header--border'
		);

		this._element.classList.add(`board-header--${tune}`);
		this.data.type = tune;
	}

	_changeSize(tune){
		const headerbox = this._element.querySelector('div');

		this.data.level = tune;
		headerbox.style.fontSize = this._fontSizeArray[tune];
	}

	_changeAlignment(tune){
		this.data.alignment = tune;
		this._element.classList.remove('board-header--center', 'board-header--right', 'board-header--left');

		this._element.classList.add(`board-header--${tune}`);
	}

	_setColor(){
		const headerbox = this._element.querySelector('div');
		headerbox.style.color = this.data.textColor;
		if(this.data.backgroundColor !== '#ffffff'){
			headerbox.style.background = this.data.backgroundColor;
		}
		headerbox.style.borderColor = this.data.borderColor;
	}

	_showColorPicker(button){
		const setbox = this._element.querySelector('form');

		const textColor =  document.createElement('input');
		const backgroundColor =  document.createElement('input');
		const borderColor =  document.createElement('input');

		textColor.type = 'color';
		textColor.value = this.data.textColor;

		backgroundColor.type = 'color';
		backgroundColor.value = this.data.backgroundColor;

		borderColor.type = 'color';
		borderColor.value = this.data.borderColor;

		setbox.insertAdjacentHTML('beforeend', '文字色：');
		setbox.appendChild(textColor);
		setbox.insertAdjacentHTML('beforeend', '<br>背景色：');
		setbox.appendChild(backgroundColor);
		setbox.insertAdjacentHTML('beforeend', '<br>枠　色：');
		setbox.appendChild(borderColor);
		
		textColor.onchange = () => {
			const headerbox = this._element.querySelector('div');

			this.data.color = textColor.value;
			headerbox.style.color = this.data.color;

			button.classList.remove(this.api.styles.settingsButtonActive);
			this._hideColorPicker();
			this._setform = false;
		};

		backgroundColor.onchange = () => {
			const headerbox = this._element.querySelector('div');
			this.data.backgroundColor = backgroundColor.value;
			if(this.data.backgroundColor === '#ffffff'){
				headerbox.style.background = 'none';
			}else{
				headerbox.style.background = this.data.backgroundColor;
			}
			if(this.data.backgroundColor !== '#ffffff' && this._element.classList.contains('board-header--normal') || this._element.classList.contains('board-header--under-line') || this._element.classList.contains('board-header--updown-line')) {
				headerbox.style.paddingLeft = '10px';
				headerbox.style.paddingRight = '10px';
			}else{
				headerbox.style.paddingLeft = '';
				headerbox.style.paddingRight = '';
			}

			button.classList.remove(this.api.styles.settingsButtonActive);
			this._hideColorPicker();
			this._setform = false;
		};

		borderColor.onchange = () => {
			const headerbox = this._element.querySelector('div');
			this.data.borderColor = borderColor.value;
			headerbox.style.borderColor = this.data.borderColor;

			button.classList.remove(this.api.styles.settingsButtonActive);
			this._hideColorPicker();
			this._setform = false;
		};
	}

	_hideColorPicker(){
		const setbox = this._element.querySelector('form');

		setbox.innerHTML = '';
	}

	save(toolsContent){
		return {
			text: toolsContent.querySelector('div').innerHTML,
			level: this.data.level,
			lineType: this.data.type,
			alignment: this.data.alignment,
			textColor: this.data.textColor,
			borderColor: this.data.borderColor,
			backgroundColor: this.data.backgroundColor
		}
	}

	validate(blockData) {
		return blockData.text.trim() !== '';
	}

	static get toolbox(){
		return {
			icon:'<svg width="10" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"><path d="M7.6 8.15H2.25v4.525a1.125 1.125 0 0 1-2.25 0V1.125a1.125 1.125 0 1 1 2.25 0V5.9H7.6V1.125a1.125 1.125 0 0 1 2.25 0v11.55a1.125 1.125 0 0 1-2.25 0V8.15z"/></svg>',
			title:'見出し'
		};
	}
}